// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    hmr: false,
    devApi: true,

    // PROD
    // coreApiUrl: 'https://forfettappapi-core.azurewebsites.net',
    // jobsWorkerApiUrl: 'https://forfettappjobsworker.azurewebsites.net',

    // DEV
    // coreApiUrl: 'https://forfettapp-api-dev-ita.azurewebsites.net',
    jobsWorkerApiUrl: 'https://forfettapp-jobsworker-dev.azurewebsites.net',

    // LOCAL
    coreApiUrl: 'https://localhost:45000',
    // jobsWorkerApiUrl: 'https://localhost:5228',

    authUrl: 'https://forfettapp-auth-dev.azurewebsites.net',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
